export default __webpack_public_path__ + "static/media/paypal.7d6da3d8.png";